module.exports = __webpack_public_path__ + "media/images/font/SofiaProLight-3cd2608c776b265d12656c7da02133a7.woff";